import { render, staticRenderFns } from "./popform.vue?vue&type=template&id=b303941e"
import script from "./popform.vue?vue&type=script&lang=js"
export * from "./popform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports